import { useState } from "react";
import * as rpc from "@1games-ru/rage-rpc";
import { Button, Card, Flex, Select, TextField } from "@radix-ui/themes";

function EventFormContainer() {
  const [name, setName] = useState<string>("");
  const [eventType, setEventType] = useState<string>("client");
  const [value, setValue] = useState<string>("");
  const [response, setResponse] = useState<[] | object>({});

  const stringifyResponse = (): string => JSON.stringify(response, null, 4);

  const call = (target: any, name: string, value: any): void => {
    let targetValue = value;

    try {
      targetValue = JSON.parse(value);
    } catch (e) {
      targetValue = value;
    }

    target(name, targetValue)
      .then((res: any): void => {
        console.log({ res });
        setResponse(res);
      })
      .catch((e: any): void => {
        console.log({ e });
        setResponse([JSON.stringify(e)]);
      });
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (eventType === "client") {
      call(rpc.callClient, name, value);
    } else if (eventType === "server") {
      call(rpc.callServer, name, value);
    }
  };

  return (
    <Card className="fixed bottom-10 right-10 p-5 w-[18rem]">
      <form onSubmit={handleSubmit}>
        <Flex direction="column" gap="3">
          <TextField.Root
            size="3"
            name="name"
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Название"
          />
          Тип ивента:
          <Select.Root
            size="3"
            value={eventType}
            required
            onValueChange={(value) => setEventType(value)}
          >
            <Select.Trigger />
            <Select.Content position="popper">
              <Select.Item value="client">Client</Select.Item>
              <Select.Item value="server">Server</Select.Item>
            </Select.Content>
          </Select.Root>
          <TextField.Root
            size="3"
            name="value"
            onChange={(e) => setValue(e.target.value)}
            required
          />
          <div>
            <div>Ответ:</div>
            <div>{stringifyResponse()}</div>
          </div>
          <Button size="3">Отправить</Button>
        </Flex>
      </form>
    </Card>
  );
}

export default EventFormContainer;
